/** 分包商资料统一刷新：本页保存即时更新，跨标签页广播，跨设备最多 30 秒刷新可见页面。
 * 回调仅更新候选资料，调用方保留选项和表单内容；隐藏页面暂停轮询，重新可见时立即取最新值。
 */
import { useEffect, useRef } from "react";
import { SUB_DIRECTORY_CHANGED, SUB_DIRECTORY_STORAGE } from "../lib/subcontractorDirectoryEvents";

export default function useSubcontractorRefresh(refresh, { enabled = true } = {}) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    if (!enabled) return;
    let pending;
    const schedule = () => {
      clearTimeout(pending);
      pending = setTimeout(() => { if (document.visibilityState === "visible") latest.current(); }, 80);
    };
    const storage = (e) => { if (e.key === SUB_DIRECTORY_STORAGE) schedule(); };
    const timer = setInterval(schedule, 30000);
    window.addEventListener(SUB_DIRECTORY_CHANGED, schedule);
    window.addEventListener("storage", storage);
    window.addEventListener("focus", schedule);
    document.addEventListener("visibilitychange", schedule);
    return () => {
      clearInterval(timer); clearTimeout(pending);
      window.removeEventListener(SUB_DIRECTORY_CHANGED, schedule);
      window.removeEventListener("storage", storage);
      window.removeEventListener("focus", schedule);
      document.removeEventListener("visibilitychange", schedule);
    };
  }, [enabled]);
}
